export default __webpack_public_path__ + "static/media/duigo-btn.b636f51e.svg";